export default __webpack_public_path__ + "static/logo-netflix-8252af9f15dd6901acff7cb08bce9820.png";